[
  {
    "id": 12,
    "documentId": "tshdxykib2hjqp9xpi6b9era",
    "institution": "Institut Teknologi Sepuluh Nopember (ITS)",
    "degree": "Bachelor of Engineering",
    "fieldOfStudy": "Computer Engineering",
    "level": "bachelor",
    "startDate": "2017-07-01",
    "endDate": "2023-07-31",
    "location": "Surabaya, Indonesia",
    "gpa": 3.8,
    "description": "Studied Computer Engineering with focus on software development, algorithms, and system design. Completed thesis on mobile application development.",
    "summary": "Bachelor of Engineering in Computer Engineering from ITS Surabaya",
    "achievements": [
      "Graduated with honors",
      "Completed mobile development thesis",
      "Active in software development projects"
    ],
    "isFeatured": false,
    "slug": "its",
    "createdAt": "2025-08-05T12:23:58.376Z",
    "updatedAt": "2025-08-05T12:23:58.376Z",
    "publishedAt": "2025-08-05T12:23:58.380Z",
    "skills": [],
    "certifications": [],
    "logo": null,
    "diploma": null,
    "transcript": null,
    "links": [],
    "seo": null
  }
]
